module.exports = __webpack_public_path__ + "img/電気回路_5_6.d7973f30.png";